import { ErrorAppComponent } from 'pods/error-app';

export const ErrorScene = () => <ErrorAppComponent />;

export default ErrorScene;
